import React, { useEffect, useState } from "react";

//Importar helpers..
import { formatDateAlt } from "../../../../helpers/date";

//Importar dependencias de Reac Time Ago.
import ReactTimeAgo from "react-time-ago";

// MessageTime: Componente que renderiza la hora del mensaje entrante dentro del Inbox.

const MessageTimeInInbox = ({ chat, setTimeDifference }) => {

    //Estado para actualizar la fecha y hora que va dentro del ReactTimeAgo.
    const [formattedDate, setFormattedDate] = useState(formatDateAlt(chat.FechaHora));  

    // Convertir la fecha a milisegundos, para pasarlo al React Time Ago.
    const fechaMilisegundos = new Date(formattedDate).getTime();

    useEffect(() => {  // Actualiza la diferencia de tiempo de llegada con la hora act.
        setFormattedDate(formatDateAlt(chat.FechaHora));
        const differenceInSeconds = Math.floor((new Date() - new Date(formatDateAlt(chat.FechaHora))) / 60000);
        setTimeDifference(differenceInSeconds);
    }, [chat.FechaHora]);

    return (
        <div className="card__plataforms-wiht-hour">
            <div className="card__hour-with-numers">
                <label><ReactTimeAgo date={fechaMilisegundos} locale="es" /></label>
            </div>

            {/*Íconos de las plataformas de llegada de los chats en el Inbox*/}
{/*             <div className={`card__plataforms  ${idChat === idChatSeleccionado ? 'active' : ''}`}>
                <FontAwesomeIcon icon={faFacebookMessenger} className="card__plataforms--icon__messenger" />
             <FontAwesomeIcon icon={faWhatsapp} className="card__plataforms--icon__whatsapp"  />
            </div> */}
        </div>
    )
};

export default MessageTimeInInbox;